<p>
  investments-plan works!
</p>